module.exports = __webpack_public_path__ + "static/fipclittledinosaurmain-d28986e9ebf38ef8bf7bbc3c4533ac16.jpeg";